import { default as hour } from './hour/services'
import { default as base_hour } from './base_hour/services'

export default {
    ...hour,
    ...base_hour,
}